import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { FormBuilder } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ArchivesService {
  constructor(private apiService: ApiService, private fb: FormBuilder) {}

  archiveVehicle(vehicleId: number, data: any) {
    return this.apiService.updateAPI(`archive/vehicle`, vehicleId, data);
  }

  getArchivedVehicles(vehicle_reference: string) {
    return this.apiService.getAPI(`archive/vehicles/${vehicle_reference}`);
  }

  getActiveIssuesByDateRange(data: any, id: number) {
    return this.apiService.getAPI(
      `active-issue-by-date/${id}?date_from=${data.x_date_from}&date_to=${data.x_date_to}`
    );
  }

  archiveIssue(data: any) {
    return this.apiService.postAPI(`archive/active-issue`, data);
  }

  getTechnicalRecordsByDateRange(data: any, id: number) {
    return this.apiService.getAPI(`technical-record-by-date/${id}?date_from=${data.y_date_from}&date_to=${data.y_date_to}`);
  }

  archiveTechnicalRecord(data: any) {
    return this.apiService.postAPI(`archive/technical-record`, data);
  }

  changeActiveIssueVehicleId(vehicle_reference: any) {
    return this.apiService.postAPI(`vehicle/active-issues`, vehicle_reference);
  }

  changeTechnicalRecordVehicleId(vehicle_reference: any) {
    return this.apiService.postAPI(`vehicle/technical-records`, vehicle_reference);
  }

  dateRangeForm = this.fb.group({
    x_date_from: [''],
    x_date_to: [''],
    y_date_from: [''],
    y_date_to: [''],
  });

  archiveForm = this.fb.group({
    vehicle_reference: [''],
    id: [''],
    // Stamped onto the archived copy; the archive dialog fills these from the
    // detected odometer segment — in-service = its first reading,
    // out-of-service = the changeover (last reading).
    date_inservice: [''],
    date_outservice: [''],
  });
}
